import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Modal, Form } from "react-bootstrap";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

import * as commonApi from "../../../api/commonApi";
import * as util from "../../../util";
import { Common, ERROR, SUCCESS, VALIDATION, WondeStatus } from "../../../helper";
import { errorMsg, success } from "../../Shared";

import "../../../assets/stlyes/Admin/PupilImport.scss";

import Wonde from "../../../assets/images/Wonde-Logo-Colour.svg"
import lockIcon2 from "../../../assets/images/lockIcon2.svg"
import lockIcon from "../../../assets/images/lock.svg"
import retryIcon from "../../../assets/images/Retry.svg"

const WondeImport = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [importStatus, setImportStatus] = useState(true);
  const [approveStatus, setApproveStatus] = useState("");
  const [disableImport, setDisableImport] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const schema = yup.object().shape({
    firstName: yup.string().required(VALIDATION.FIRST_NAME_IS_REQUIRED).min(2, VALIDATION.NAME_MUST_HAVE_AT_LEAST_2_CHARACTERS).max(50, VALIDATION.NAME_CANT_BE_LONGER_THAN_50_CHARACTERS),
    lastName: yup.string().required(VALIDATION.LAST_NAME_IS_REQUIRED).min(2, VALIDATION.NAME_MUST_HAVE_AT_LEAST_2_CHARACTERS).max(50, VALIDATION.NAME_CANT_BE_LONGER_THAN_50_CHARACTERS),
    schoolName: yup.string().required(VALIDATION.SCHOOL_Name_IS_REQUIRED).min(2, VALIDATION.NAME_MUST_HAVE_AT_LEAST_2_CHARACTERS).max(50, VALIDATION.NAME_CANT_BE_LONGER_THAN_50_CHARACTERS),
    email: yup.string().required(VALIDATION.EMAIL_IS_REQUIRED).email(VALIDATION.PLEASE_ENTER_VALID_EMAIL_ADDRESS),
    schoolId: yup.string().required(VALIDATION.WONDE_SCHOOL_ID_IS_REQUIRED),
    Note: yup.string()
  });

  const { register, handleSubmit, reset, formState: { errors } } = useForm({ resolver: yupResolver(schema) });

  useEffect(() => {
    getImportStatus();
  }, [])

  const getImportStatus = async () => { //Commented to push to production
    setIsLoading(true);
    const importStatus = await commonApi.getWondeStatus();
    setImportStatus(importStatus?.Items?.importStatus);
    setApproveStatus(importStatus?.Items?.approveStatus);
    setIsLoading(false);
  }

  const importFromWonde = async () => {
    setIsLoading(true);
    setDisableImport(true);
    let importPupilFromWonde = await commonApi.importFromWonde();
    if (!util.isEmptyObject(importPupilFromWonde)) {
      success(SUCCESS.IMPORT_SUCCESS)
      setTimeout(() => {
        window.location.reload();
      }, 5000);
    } else {
      errorMsg(ERROR.IMPORT_ERROR)
      setDisableImport(false)
    }
    setIsLoading(false);
  }

  const handleCancel = () => {
    setShowModal(false)
    reset()
  }

  const requestAccess = async (schoolData) => {
    setIsLoading(true);
    let data = {
      first_name: schoolData.firstName,
      last_name: schoolData.lastName,
      school_name: schoolData.schoolName,
      phone_number: "9898989898",
      email_address: schoolData.email,
      notes: "Import From Wonde",
      schoolId: schoolData.schoolId,
    }
    const requestWondeSchoolAccess = await commonApi.requestWondeSchoolAccess(data)
    if (!util.isEmptyObject(requestWondeSchoolAccess)) {
      success(SUCCESS.ACCESS_REQUESTED_WAITING_FOR_APPROVAL)
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    }
    console.log({ data: data, requestWondeSchoolAccess, importStatus, isLoading });
    setShowModal(false)
    reset()
    setIsLoading(false);
  }

  return (
    <div className="wonde-div-main">
      <img src={Wonde} alt="" className="wonde-img" />
      <div className="d-flex justify-content-center align-items-flex-start flex-column" style={{ gap: "30px" }}>
        {!(approveStatus === WondeStatus.schoolApproved) ? (approveStatus === WondeStatus.pending)? <button className="access-pending-button"><span>{Common.AcessPendingWonde}</span><img src={lockIcon} alt="lock" /></button> :<button className={!(approveStatus === WondeStatus.pending || approveStatus === WondeStatus.schoolApproved) ? "access-from-wonde-active" : "access-from-wonde-inactive"} disabled={(approveStatus === WondeStatus.pending || approveStatus === WondeStatus.schoolApproved)} onClick={() => setShowModal(true)}>{Common.AcessFromWonde}<img src={lockIcon} alt="lock" /></button> : <button className={!(importStatus) ? "access-from-wonde-active" : "access-from-wonde-inactive"} onClick={importFromWonde} disabled={importStatus}><span>{Common.ImportFromWonde}</span><img src={lockIcon} alt="lock" /></button>}

        <button onClick={importFromWonde} disabled={true} className={!(disableImport) ? "update-pupils-from-wonde-inactive" : "update-pupils-from-wonde-inactive"}><span>{Common.UpdatePupils}</span><img src={retryIcon} alt="retry" /></button>
      </div>
      {/* <div className="d-flex justify-content-center align-items-flex-start flex-column">
        {!(approveStatus === WondeStatus.schoolApproved) ? <>
          {!isLoading && !importStatus && <button style={styles.wondeButton} disabled={approveStatus === WondeStatus.pending} onClick={() => setShowModal(true)}>{Common.AcessFromWonde}</button>}
        </> : <>
          {!isLoading && !importStatus && !disableImport && <button style={styles.wondeButton} onClick={importFromWonde}>{Common.UpdatePupils}</button>}
        </>}
      </div> */}
      <div>
        <span className="not-signed-to-wonde">Not signed up to Wonde yet? <a href="https://www.wonde.com/school/" target="_blank" rel="noopener noreferrer" className="not-signed-to-wonde">Click here.</a></span>
      </div>
      <Modal show={showModal} className="comment-modal" style={{ marginLeft: "0%",marginTop:"0%" }}>
        <Modal.Header className="comment-modal-header" style={{ flexDirection: "column", alignItems: "flex-start",borderBottom:"#FFFFFF" }}>
          <span className="d-flex" style={{ gap: "10px" }}><img src={lockIcon2} alt="" style={{ fill: "#084059" }} /><h3>{Common.RequestAccessFromWonde}</h3></span>
          &nbsp;
          <span>This request will be verified by your school’s Wonde Administrator</span>
        </Modal.Header>
        <Modal.Body className="comment-modal-body">
          <Form onSubmit={handleSubmit(requestAccess)} style={{display:"flex",flexDirection:"column",gap:"20px"}}>
            <div>
              {/* <h6 htmlFor="firstName" className="mt-3">{Common.FirstName}</h6> */}
              <Form.Control type="text" id="firstName" name="firstName" placeholder="First Name" {...register("firstName")} className="custom-input-for-import-modal" />
              {errors.firstName && <div className="error-message">{errors.firstName.message}</div>}
            </div>

            <div>
              {/* <h6 htmlFor="lastName" className="mt-3">{Common.LastName}</h6> */}
              <Form.Control type="text" id="lastName" name="lastName" {...register("lastName")} className="custom-input-for-import-modal" placeholder="Last Name" />
              {errors.lastName && <div className="error-message">{errors.lastName.message}</div>}
            </div>

            <div>
              {/* <h6 htmlFor="schoolName" className="mt-3">{Common.SchoolName}</h6> */}
              <Form.Control type="text" id="schoolName" name="schoolName" {...register("schoolName")} className="custom-input-for-import-modal" placeholder="School Name" />
              {errors.schoolName && <div className="error-message">{errors.schoolName.message}</div>}
            </div>

            <div>
              {/* <h6 htmlFor="email" className="mt-3">{Common.Email}</h6> */}
              <Form.Control type="email" id="email" name="email" {...register("email")} className="custom-input-for-import-modal" placeholder="Email" />
              {errors.email && <div className="error-message">{errors.email.message}</div>}
            </div>

            <div>
              {/* <h6 htmlFor="schoolId" className="mt-3">{Common.WondeSchoolID}</h6> */}
              <Form.Control type="schoolId" id="schoolId" name="schoolId" {...register("schoolId")} className="custom-input-for-import-modal" placeholder="Wonde school ID" />
              {errors.schoolId && <div className="error-message">{errors.schoolId.message}</div>}
            </div>

            {/* <div>
              <h6 htmlFor="Notes" className="mt-3">{Common.Notes}</h6>
              <Form.Control type="Notes" id="Notes" name="Notes" {...register("Notes")} />
              {errors.schoolName && <div className="error-message">{errors.schoolName.message}</div>}
            </div> */}

            <Modal.Footer className="comment-modal-footer" style={{ justifyContent: "flex-end",marginRight:"-17px",borderTop:"#FFFFFF" }}>
              <button className="cancelButton-for-import-modal" type="button" onClick={handleCancel}>{Common.Cancel}</button>
              <button name="addComment" type="submit" className="submit-button-for-import-modal" > {Common.SubmitRequest}</button>
            </Modal.Footer>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  )
}

export { WondeImport };
